module.exports = __webpack_public_path__ + "01_mustache_brown.66c63602.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer3/01_mustache_brown.png
// module id = SNMt
// module chunks = 0